import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { PARTNER_BY_ID, PARTNERS } from '../../common/endpoints';
import { Partner } from '../../model';
import { HttpService } from '../../service/http.service';

@Injectable()
export class PartnerService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private httpService: HttpService
    ) { }

    getPartnerById(partnerId: string): Promise<Partner> {
        const endpoint = PARTNER_BY_ID.replace('{id}', partnerId);
        return this.httpService.get<Partner>(endpoint).toPromise();
    }

    savePartner(body: any, partner: Partner): Observable<Partner> {
        if (body.id) {
            return this.httpService.put<Partner>(PARTNER_BY_ID.replace('{id}', partner.id), body);
        } else {
            delete body.id;
            return this.httpService.post<Partner>(PARTNERS, body);
        }
    }

    deletePartner(partner: Partner): Observable<void> {
        return this.httpService.delete<void>(PARTNER_BY_ID.replace('{id}', partner.id));
    }

    patchPartner(partnerId: string, body: any): Promise<Partner> {
        return firstValueFrom(this.httpService.patch<Partner>(PARTNER_BY_ID.replace('{id}', partnerId), body));
    }

}